module.exports = __webpack_public_path__ + "img/avatar-recolored.7441ced3.svg";